module.exports = __webpack_public_path__ + "img/drew-lasker.6f15e4d4.jpg";